import Vue from 'vue';
import { Component, Inject, Emit, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { DisplayOptions } from '@/types/store-types';

const project = namespace('project');

@Component
export default class DisplayOptionsModal extends Vue {
  private options: DisplayOptions = {
    showWeekend: false,
    hourlyRate: false,
    startDate: false,
    endDate: false,
    plannedTotal: false,
  };

  private showAll = false;

  @project.Getter('displayOptions')
  private displayOptions: DisplayOptions;

  @project.Action('saveDisplayOptions')
  private saveDisplayOptions(options: DisplayOptions) {
  }

  get allChecked(): boolean {
    let allChecked = true;
    Object.values(this.options).forEach((v) => {
      if (v === false) {
        allChecked = false;
      }
    });
    this.showAll = allChecked;
    return this.showAll;
  }

  private copyFromStore() {
    this.options = { ...this.displayOptions };
  }

  private toggleShowAll() {
    this.options.showWeekend = this.showAll;
    this.options.hourlyRate = this.showAll;
    this.options.startDate = this.showAll;
    this.options.endDate = this.showAll;
    this.options.plannedTotal = this.showAll;
  }
}
